export default __webpack_public_path__ + "static/kitchen-6555eb1289cf4481189e9972646bf175.gif";